<template>
   <v-flex pb-0 pt-1 v-bind="$attrs" xs12>
      <v-text-field :placeholder="pholder" :rules="validationRules" :value="number" box class="clean-style"
                    browser-autocomplete="nope" ref="numberEditor" v-bind="$attrs"
                    v-money="fieldMask" v-on="listeners" validate-on-blur/>
   </v-flex>
</template>

<script>
   import numeral from 'numeral';
   import { VMoney } from 'v-money';
   import Rules from './validationRules';

   export default {
      directives: { money: VMoney },

      name: 'a-number-field',

      props: {
         value: {
            required: false
         },
         floating: {
            type: Boolean,
            required: false,
            default: false
         },
         align: {
            type: String,
            required: false,
            default: 'right'
         },
         numberMask: {
            required: false
         },
         numberDecimals: {
            required: false,
            default: 2
         },
         validate: {
            type: String,
            required: false
         }

      },

      data () {
         return {
            rawInput: null,
            focusValue: numeral(0).format('0.' + '0'.repeat(this.numberDecimals)), //TODO: base for changedBlur event
            number: numeral(0).format('0.' + '0'.repeat(this.numberDecimals)),
            numberMasks: {
               us: {
                  decimal: '.',
                  thousands: ',',
                  prefix: '$ ',
                  suffix: '',
                  precision: this.numberDecimals
               },
               fixed_us: {
                  decimal: '.',
                  thousands: ',',
                  prefix: '',
                  suffix: '',
                  precision: this.numberDecimals
               },
               p_us: {
                  decimal: '.',
                  thousands: ',',
                  prefix: '',
                  suffix: '%',
                  precision: this.numberDecimals
               },
               qty: {
                  decimal: '.',
                  thousands: ',',
                  prefix: '',
                  suffix: '',
                  precision: this.numberDecimals
               },
               rs: {
                  decimal: ',',
                  thousands: '.',
                  prefix: 'R$ ',
                  suffix: '',
                  precision: this.numberDecimals
               },
               fixed_rs: {
                  decimal: ',',
                  thousands: '.',
                  prefix: '',
                  suffix: '',
                  precision: this.numberDecimals
               },
               p_rs: {
                  decimal: ',',
                  thousands: '.',
                  prefix: '',
                  suffix: '%',
                  precision: this.numberDecimals
               },
               factor_rs: {
                  decimal: ',',
                  thousands: '.',
                  prefix: '',
                  suffix: '',
                  precision: this.numberDecimals
               }
            }
         };
      },

      watch: {
         value: {
            handler: function (newValue) {
               newValue = parseFloat(newValue);
               // console.log('Value watch: ', newValue, this.number);
               let v = newValue || 0;
               // console.log(this.rawInput, this.number, newValue,'valores 1')
               if (this.rawInput && this.number !== newValue) {
                  // console.log(this.numberDecimals,'this.numberDecimals')
                  if (this.numberDecimals) {
                     let p = this.fieldMask && this.fieldMask.suffix === '%' ? '%' : '';
                     v = `${numeral(v).format('0.' + '0'.repeat(this.numberDecimals))}${p}`;
                     // console.log(newValue, v, p, 'valores 2');
                  }
                  this.rawInput.value = v;
               }
            },
            immediate: true
         }

      },

      computed: {
         fieldMask () {
            let mask = {};
            if (this.numberMask && typeof this.numberMask === 'object') {
               mask = this.numberMask;
            } else {
               mask = this.numberMasks[this.numberMask];
            }

            return mask;
         },

         listeners () {
            return {
               ...this.$listeners,
               input: (value) => {
                  if (!this.$attrs.readonly && this.$refs.numberEditor.isFocused) {
                     // console.log('Number inputed: ', value);
                     if(this.fieldMask && this.fieldMask.suffix === '%'){
                        value = value.replace(this.fieldMask.suffix,'')
                     }
                     value = numeral(value).value()
                     if (this.number !== value) {
                        // console.log(value, this.number,'value number')
                        // console.log(numeral(value),'numeral value')
                        this.number = value;
                        
                        this.$emit('input', value);
                     }
                  }
               }
            };
         },
         pholder () {
            let prop = this.placeholder;
            return (this.floating) ? (prop || '') : ' ';
         },

         validationRules () {
            let rules = [];

            if (this.validate) {
               let rulesArray = this.validate.split(',');
               rulesArray.forEach(r => rules.push(Rules[r.trim()]));
            }

            return rules;
         },

         valid() {
            return this.$refs.numberEditor.valid;
         }
      },

      mounted () {
         this.rawInput = this.$el.querySelector('input');
         if (this.rawInput) {
            this.rawInput.value = numeral(parseFloat(this.value)).format('0.' + '0'.repeat(this.numberDecimals));

            this.rawInput.style.textAlign = this.align;
         }
      }


   };
</script>

<style>


</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/ANumberField.vue